import { AddressAutocompleteInput } from "@/components/common/AddressAutocompleteInput";
import { inputClass } from "@/components/manufacturing/manufacturingSurfaceClasses";
import { formatStructuredAddressOneLine } from "@/lib/addressValidation/addressFormat";

/** Single-line plant delivery address with Google lookup. */
export function PlantDeliveryAddressField(props: {
  value: string;
  onChange: (next: string) => void;
  disabled?: boolean;
}) {
  return (
    <AddressAutocompleteInput
      value={props.value}
      onChange={props.onChange}
      onPick={(pick) => {
        props.onChange(
          pick.formatted.trim() || formatStructuredAddressOneLine(pick.normalized),
        );
      }}
      className={inputClass}
      placeholder="Start typing a street address…"
      disabled={props.disabled}
      hintWhenDisabled="Autocomplete unavailable — type the delivery address."
    />
  );
}
